import MuiAlert from '@mui/material/Alert';

import { styled } from 'helpers';
import { colors } from 'Theme/colors';

import { AlertColor, AlertProps } from './types';

type ColorProperty = 'background' | 'icon' | 'message';

const alertColors = {
  info: {
    background: colors.blue[50],
    icon: colors.blue[800],
    message: colors.blueGrey[900],
  },
  error: {
    background: colors.deepOrange[50],
    icon: colors.deepOrange[900],
    message: colors.deepOrange[900],
  },
  success: {
    background: colors.teal[50],
    icon: colors.teal[900],
    message: colors.teal[900],
  },
  warning: {
    background: colors.orange[50],
    icon: colors.deepOrange[900],
    message: colors.deepOrange[900],
  },
};

const getAlertColor = (severity: AlertColor | undefined, property: ColorProperty) => {
  if (!severity) return alertColors.info[property];

  return alertColors[severity][property] || alertColors.info[property];
};

// prettier-ignore
export const StyledAlert = styled(MuiAlert, {shouldForwardProp: (prop) => prop !== 'fullWidth',})<AlertProps>`
  align-items: flex-start;
  background-color: ${({ severity }) => getAlertColor(severity, 'background')};
  border-radius: 8px;
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};
  padding: 12px 16px;

  .MuiAlert-icon {
    align-items: center;
    color: ${({ severity }) => getAlertColor(severity, 'icon')};
    margin-right: 8px;
    padding: 4px;
  }

  .MuiAlert-message {
    padding: 0;
    min-height: 24px;
    display: flex;
    align-items: center;

    &,
    a {
      color: ${({ severity }) => getAlertColor(severity, 'message')};
    }
  }

  .MuiAlert-action {
    padding: 0 0 0 8px;
    margin-right: 0px; // hack to prevent collapsing padding between close action and alert container

    > .MuiIconButton-root {
      &:hover,
      &:active,
      &.Mui-focusVisible {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }
`;

export default StyledAlert;
